import { useMemo } from 'preact/hooks';
import { PageTags } from './page-tags';
import { useServices } from '@/services-context';

const {
    PUBLIC_TITLE,
    PUBLIC_DESCRIPTION,
} = import.meta.env;

export const HeadDefaults = () => {
    const services = useServices();

    const metaDataset = useMemo(() => ({
        title: services.pagemeta.createHomePageTitle() || PUBLIC_TITLE,
        description: services.pagemeta.createHomePageDescription() || PUBLIC_DESCRIPTION,
    }), []);

    return <PageTags meta={metaDataset} />;
};